export const VENDOR_COMMANDS = {
  CARVANA_CONTACT_FOLLOWUP_NAME: 'carvana_contact_followup_name',
  CARVANA_CUSTOMER_CHAT_RATING: 'carvana_customer_chat_rating',
  CARVANA_RATING_CONTACT_FOLLOWUP_VERIFICATION: 'carvana_contact_followup_verification',
  CARVANA_CONTACT_FOLLOWUP_VERIFICATION_RESEND: 'carvana_contact_followup_verification_resend',
  CARVANA_CONTACT_FOLLOW_UP_QUESTION: 'carvana_contact_followup_question',
  CARVANA_CONTACT_FOLLOW_UP_NAME_SHOW: 'carvana_contact_followup_name_show',
  CARVANA_FEEDBACK_REQUEST_FORM: 'carvana_customer_chat_feedback',
  CARVANA_CUSTOMER_JOURNEY: 'carvana_customerjourney',
  CARVANA_END_CHAT: 'end_advocate_chat',
  CARVANA_CANCEL_ESCALATION: 'carvana_cancel_escalation',
  CARVANA_AI_SEND_MESSSAGE: 'carvana_send_ai_message',
} as const;
